import logger from "../utils/logger";
export const loadCompanyUsers = async (request, companyId, setCompanyUsers) => {
  if (!companyId) return;
  const usersList = await request(`/api/v1/users/?company_id=${companyId}`, {});
  setCompanyUsers(usersList);
};
export const loadProfileSummary = async (request, userId, setProfileSummary, setProfileSummaryBusy) => {
  if (!userId) return;
  setProfileSummaryBusy(true);
  try {
    const data = await request(`/api/v1/users/${userId}/summary`, {});
    setProfileSummary(data);
  } catch (error) {
    logger.error(error);
  } finally {
    setProfileSummaryBusy(false);
  }
};
export const loadWorkspaces = async (request, companyId, setWorkspaces, setTaskForm) => {
  const data = await request('/api/v1/workspaces/', {});
  setWorkspaces(data);
  if (setTaskForm && data.length) {
    setTaskForm(prev => prev.workspace_id ? prev : {
      ...prev,
      workspace_id: data[0].id
    });
  }
};
export const loadCurrentUser = async (request, setUser) => {
  const me = await request('/api/v1/auth/me', {});
  setUser(me);
};
export const loadMarketplaces = async (request, companyIdValue, setMarketplaces) => {
  const url = companyIdValue ? `/api/v1/marketplaces/?company_id=${companyIdValue}` : '/api/v1/marketplaces/';
  const items = await request(url, {});
  setMarketplaces(items);
};
export const loadCompany = async (request, setCompanyInfo) => {
  const data = await request('/api/v1/companies/me', {});
  setCompanyInfo(data);
};
export const updateCompanyMode = async (request, mode) => request('/api/v1/companies/me', {
  method: 'PATCH',
  body: JSON.stringify({
    company_mode: mode
  })
});
